var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h6 mb-4"},[_vm._v("По всем вопросам:")]),_c('v-btn',{attrs:{"href":_vm.mailGeneralLink,"text":"","color":"info"}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-email")]),_vm._v(" Написать на электропочту ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }